export default "50a810602482c85f.svg"